import EmptyFolder from './EmptyFolder';

export default EmptyFolder;